import {
  GetDevicesQuery,
  GetDevicesResponse,
} from '@eppendorf/vnls-device-service-utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetcher } from '$shared/fetch';
import {
  createPathWithQueryParams,
  DEVICE_SERVICE_BASE_PATH,
  objectToURLSearchParams,
} from '$shared/utils/api-paths';

export const devicesv2QueryKey = 'devicesv2';

export const createDevicesV2QueryWithQueryParams = (queryParams: GetDevicesQuery) => ({
  queryKey: [devicesv2QueryKey, ...objectToURLSearchParams(queryParams).values()],
  queryFn: async () => {
    const response = await fetcher.get<GetDevicesResponse>(
      createPathWithQueryParams(DEVICE_SERVICE_BASE_PATH, queryParams),
    );

    return response;
  },
  placeholderData: keepPreviousData,
  refetchInterval: 5000,
});

export const useDevicesV2WithQueryParams = (queryParams: GetDevicesQuery) =>
  useQuery(createDevicesV2QueryWithQueryParams(queryParams));
